import { Link } from "@remix-run/react";
import { type ReactNode } from "react";
import { cn } from "../utils/misc.tsx";

const linkBaseClasses = 'h-10 no-underline inline-flex items-center justify-center rounded-md text-sm font-bold ring-offset-background  focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50'
const linkBaseHoverClasses = 'decoration-2 underline-offset-4 hover:underline focus:underline'
const specialClasses = 'px-4 decoration-stone-900 bg-amber-300 text-stone-900 ring-amber-300 hover:bg-slate-900 dark:hover:bg-amber-400 hover:text-slate-50 dark:hover:text-slate-900 light:focus:bg-slate-900 light:focus:text-slate-50 focus:ring-2 ring-offset-2 active:bg-amber-300 text-sm'


export type NavItem = {
  to: string
  title: string
  value: ReactNode
  special?: boolean
  isActive?: boolean,
}

export function MainNavigation({ items, className }: {
  items: NavItem[],
  className?: string,
}) {
  return <nav className={className}>
    <ul className="flex w-screen sm:w-fit justify-between">
      {items.map(item => {
        return <li key={item.to} className="px-4 first:pl-0 last:pr-0 py-2">
          <Link
            to={item.to}
            title={item.title}
            className={item.special ?
              cn(linkBaseClasses, specialClasses) :
              cn(linkBaseClasses, linkBaseHoverClasses, item.isActive && 'underline')
            }
          >
            {item.value}
          </Link>
        </li>
      })}
    </ul>
  </nav>
}